module.exports = {
	"ha": "nha",
	"id": 5.3,
	"report": {
		"ha": "Northern Health",
		"group": "HSDA",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Northern Health by Age Category, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -195,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "55%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "55%",
				"height": "45%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -80,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 84.61538461538461,
						"dataLabels": {
							"enabled": true,
							"format": "11",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 61.53846153846154,
						"dataLabels": {
							"enabled": true,
							"format": "8",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 53.84615384615385,
						"dataLabels": {
							"enabled": true,
							"format": "7",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 38.46153846153847,
						"dataLabels": {
							"enabled": true,
							"format": "5",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 38.46153846153847,
						"dataLabels": {
							"enabled": true,
							"format": "5",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": true,
							"format": "38",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 92.10526315789474,
						"dataLabels": {
							"enabled": true,
							"format": "35",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 89.47368421052632,
						"dataLabels": {
							"enabled": true,
							"format": "34",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.526315789473685,
						"dataLabels": {
							"enabled": true,
							"format": "23",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 21.052631578947366,
						"dataLabels": {
							"enabled": true,
							"format": "8",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 98.4126984126984,
						"dataLabels": {
							"enabled": true,
							"format": "62",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 93.65079365079364,
						"dataLabels": {
							"enabled": true,
							"format": "59",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.47619047619048,
						"dataLabels": {
							"enabled": true,
							"format": "57",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 74.60317460317461,
						"dataLabels": {
							"enabled": true,
							"format": "47",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 34.92063492063492,
						"dataLabels": {
							"enabled": true,
							"format": "22",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 97.6470588235294,
						"dataLabels": {
							"enabled": true,
							"format": "166",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 90.58823529411765,
						"dataLabels": {
							"enabled": true,
							"format": "154",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.47058823529412,
						"dataLabels": {
							"enabled": true,
							"format": "147",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 78.82352941176471,
						"dataLabels": {
							"enabled": true,
							"format": "134",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 50,
						"dataLabels": {
							"enabled": true,
							"format": "85",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -15.384615384615385,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -27.27272727272727,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.5,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -28.57142857142857,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.8947368421052655,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -2.857142857142858,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -32.35294117647059,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -65.21739130434783,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -1.5873015873015928,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.8387096774193505,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.3898305084745783,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.543859649122805,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -53.191489361702125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -2.352941176470591,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -7.2289156626506035,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.545454545454541,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.843537414965985,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -36.56716417910447,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=13"
			},
			{
				"x": 9,
				"text": "30–39<br>n=38"
			},
			{
				"x": 15,
				"text": "40–49<br>n=63"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=170"
			}
		],
		"dataTable": {
			"< 30": [
				13,
				11,
				8,
				7,
				5,
				5
			],
			"30–39": [
				38,
				38,
				35,
				34,
				23,
				8
			],
			"40–49": [
				63,
				62,
				59,
				57,
				47,
				22
			],
			"≥ 50": [
				170,
				166,
				154,
				147,
				134,
				85
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_nha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_nha_5_3.json
// module id = 270
// module chunks = 0